import * as VueRouter from 'vue-router';
import { fetchAuthSession, signOut } from 'aws-amplify/auth'
import Cookies from "js-cookie"
import sls from "@/store/storage"
import { applyPortalHandoff } from "@/util/sessionHandoff"

// MODULE ROUTES
import siteTrackRoutes from "../../Site-Track/router/siteTrackRoutes";
import siteCommandRoutes from "../../Site-Command/router/siteCommandRoutes";
import siteScanRoutes from "../../Site-Scan/router/siteScanRoutes";
import siteUniteRoutes from "../../Site-Unite/router/siteUniteRoutes";
import alertsRoutes from "./alertsRoutes";
import reportsRoutes from "../../Reports/router/reportsRoutes";
import configurationRoutes from "../../Configuration/router/configurationRoutes";
import administrationRoutes from "../../Administration/router/administrationRoutes";

// SHARED
import DashboardPage from "@/views/DashboardPage.vue";
import NotFound from "@/views/404Page.vue";
import store from "../store";
import NoAvailableSitesPage from "@/views/NoAvailableSitesPage.vue";
import siteMap from "@/views/SiteMap.vue";

let routes = [
  ...siteTrackRoutes,
  ...siteCommandRoutes,
  ...siteScanRoutes,
  ...siteUniteRoutes,
  ...alertsRoutes,
  ...reportsRoutes,
  ...configurationRoutes,
  ...administrationRoutes,
  {
    path: "/",
    name: "Dashboard",
    component: DashboardPage,
    meta: { requiresAuth: true, checkPermissions: false, title: "CruzControl | Dashboard" },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/Settings/SettingsPage.vue"),
    meta: { requiresAuth: true, title: "CruzControl | Settings" },
  },
  {
    path: "/support",
    name: "Support",
    component: () => import("@/views/SupportPage.vue"),
    meta: { requiresAuth: true, title: "CruzControl | Support" },
  },
  {
    path: "/messages",
    name: "Messages",
    component: () => import("@/views/Messages/MessagesPage.vue"),
    meta: { requiresAuth: true, title: "CruzControl | Messages" },
  },
  {
    path: "/sitemap",
    name: "SiteMap",
    component: siteMap,
    meta: { requiresAuth: true, title: "CruzControl | Site Map" },
  },
  {
    path: '/404',
    component: NotFound,
    meta: {
      requiresAuth: true,
      title: "CruzControl | 404 Page Not Found"
    }
  },
  {
    path: '/noSite',
    component: NoAvailableSitesPage,
    meta: {
      requiresAuth: false,
      title: "CruzControl | No Available Sites"
    }
  },
  {
    path: '/Releases',
    component: () => import("@/views/ReleasesPage.vue"),
    meta: {
      title: "CruzControl | Releases"
    }
  },
  {
    path: '/dev-login',
    component: () => import("@/views/DevLogin.vue"),
    meta: {
      devOnly: true,
      title: "CruzControl | DEV LOGIN"
    }
  },
  {
    path: '/:pathMatch(.*)*', redirect: '/404'
  },
];

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // return { top: 0 }
  },
});

router.beforeEach(async (to, from, next) => {
  // console.log("Router doing some routing")
  if (import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" && to.meta.devOnly) {
    next()
    return
  }
  if (import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" && to.meta.requiresAuth && !to.meta.devOnly && store.getters.getUserId === null) {
    next("/dev-login")
    return
  }
  if (import.meta.env.VITE_DEV_NETWORK_ACCESS !== "true" && to.meta.devOnly === true) {
    next("/");
    return
  }
  // console.log("session timestamp: ", store.state.sessionTimestamp)
  // No-op unless we arrived from the portal and main.js hasn't already claimed the stamp.
  applyPortalHandoff(store)
  if (store.state.sessionTimestamp != null && new Date() - new Date(store.state.sessionTimestamp) > 3600000) {
    store.commit("LogOutAT");
    Cookies.remove("cruzcontrol");
    Cookies.remove("cruzcontrolSite");
    sls.remove("cruzcontrolSite");
    store.commit("setActiveSite", null);
    store.commit("setSessionTimestamp", null);
    if (import.meta.env.VITE_DEV_NETWORK_ACCESS === "true") next("/dev-login")
    else location.href = 'https://portal.cruzcontrol.app/inactivity';
    return
  }
  if (to.meta.requiresAuth && import.meta.env.VITE_OFFLINE_DEV !== "true") {
    try {
      if (store.getters.getUserId === null) throw new Error("No user ID");
      const session = await fetchAuthSession();
      store.commit("setCurrentSessionData", {
        accesstoken: session.tokens?.accessToken.toString(),
        idtoken: session.tokens?.idToken.toString(),
      });
      to.meta.from = from.fullPath
      await store.dispatch('init');
      next();
    } catch (err) {
      console.log(err);
      store.commit("LogOutAT");
      Cookies.remove("cruzcontrol");
      Cookies.remove("cruzcontrolSite");
      sls.remove("cruzcontrolSite");
      store.commit("setActiveSite", null);
      store.commit("setSessionTimestamp", null);
      if (import.meta.env.VITE_DEV_NETWORK_ACCESS === "true") {
        try {
          signOut().then(() => {
            Cookies.remove("cruzcontrol");
            Cookies.remove("cruzcontrolSite");
            sls.remove("cruzcontrolSite");
            next("/dev-login");
          });
        } catch (error) {
          console.error('error signing out: ', error);
        }
      }
      else if (err.message === 'Refresh Token has expired') {
        return location.href = 'https://portal.cruzcontrol.app/inactivity';
      }
      else {
        return location.href = 'https://portal.cruzcontrol.app/login';
      }
    }
  }
  else
  {
    to.meta.from = from.fullPath
    next()
  }
})


/**router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isATAuthenticated) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresCognitoAuth)) {
    // if fully authenticated just go to homepage
    if (store.getters.isATAuthenticated) {
      next("/");
      return
    }
    // if logged in to Cognito but not openMaint, go to reset password page
    else if (store.getters.cognitoUsername) {
      next();
      return
    }
    // if not logged in at all, redirect to login page
    next('/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isATAuthenticated) {
      next("/");
      return;
    }
    next();
  } else {
    next();
  }
});**/

/*async function checkUserIdValidity() {
  //console.log("Running check user ID function")
  // Blank Cognito Data
  let cognitoData;
  // Check with Cognito to get our Current user via Cognito Cookies
  await Auth.currentUserInfo()
      .then(response => {
        cognitoData = response
      })
  // Check with Portal API to get our real user
  let user = (await getUser(cognitoData.attributes.email))[0]
  // Verify we are who we say we are as a client.
  if(user.id === this.getUserId)
  {
    //Load Employee list from Portal. Employee is a 1:1 user to site representation
    let myEmployees = (await getEmployeesList(user.id));
    // If state.active_site is null, set defaults.
    console.log(myEmployees[0])
    if(myEmployees[0]){
      if(this.getActiveSite === null){
        this.setActiveSite(myEmployees[0]);
        this.setPermissionSet(myEmployees[0].permissions)
        this.setEmployeeId(myEmployees[0].id)
        this.setSiteId(myEmployees[0].site_id)
      }
      // set a global state for employee sites.
      this.setEmployeeSites(myEmployees)
    }
    else
    {
      await this.$router.push('/noSite')
    }
  }
  // User ID does not match Login ID.. They tried to do a bad thing.
  else
  {
    console.log(user);
    console.log(cognitoData)
  }
}*/

async function checkModulePermissions(to) {
  // console.log(store.getters.getAvailableModules)
  // console.log("feature: ", to.meta.feature)
  // console.log(store.getters.getAvailableFeatures)
  // console.log("view: ", to.params.subPage)
  // console.log(store.getters.getAvailableViews)
  if (!to.meta.module) return true
  if (store.getters.getIsTenantSuperuser) return true
  if (to.meta.internal) return false
  if (to.meta.washlink && !store.getters.getPOSSystem) return false
  if (store.getters.getUserManagementAccess && (
    to.meta.feature === "user_management" || to.meta.feature === "thresholds"
  )) return true
  return store.getters.getAvailableModules?.includes(to.meta.module)
    && (to.meta.feature ? store.getters.getAvailableFeatures[to.meta.module]?.[to.meta.feature] : true)
    && ((to.meta.feature && to.params.subPage) ? store.getters.getAvailableViews[to.meta.module]?.[to.meta.feature]?.[to.params.subPage] : true)
}

router.beforeEach(async(to, from, next) => {
  // console.log(from)
  // console.log(to)
  if (store.state.noSiteAccess && to.path !== "/settings" && to.path !== "/support" && to.path !== "/noSite") {
    return next("/noSite");
  }
  if (store.getters.isReroutePrevented) {
    store.commit("setToPath", to)
    if (store.getters.getReroutePrompt[0]) store.commit("setPrompt", store.getters.getReroutePrompt)
    next(false)
    return
  }
  if (to.meta.checkPermissions && to.path != from.path && import.meta.env.VITE_OFFLINE_DEV !== "true") {
    //getPermissionsFromStore here.
    //console.log("Logging to path")
    //console.log(to)
    //console.log("Logging from path")
    //console.log(from)
    /**
     * Check to see if we have user permissions.
     */
    if (await checkModulePermissions(to)) next()
    /**
     * We don't have module permissions. Send to 404.
     */
    else {
      console.log("404")
      next("/404");
    }
  }
  else {
    next();
  }
});

router.beforeResolve(async(to, from, next) => {
  next();
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// router.options.history.listen((to, from, info) => {
//   // info.type will be: "pop" | "push" | "replace"
//   console.log("info.type: ", info)
//   store.commit("setLastNavWasPop", info.type === "pop"); // "pop" = BACK or FORWARD
// });

router.afterEach(async (to) => {
  const title = typeof to.meta.title === "function"
    ? to.meta.title(to)
    : to.meta.title

  document.title = title || "CruzControl";
  // Cleanup reset after each navigation — but only if it was true
  // if (store.state.lastNavWasPop) {
  //   console.log("Resetting lastNavWasPop to false after navigation")
  //   setTimeout(() => store.commit("setLastNavWasPop", false), 500); // small delay to ensure any watchers have time to read the true value
  // }
});

router.options.history.listen((to, from, info) => {

  // info.type will be: "pop" | "push" | "replace"
  // console.log("info.type: ", info)

  if (info.type === "pop") {

    const position = window.history.state?.position ?? 0;

    store.commit("setLastPopNavigationPosition", position);

  }

});

export default router;